import toastr from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { SPARK_RESOURCE_TYPES } from 'constants/common';
import { useBatchRemoveOperations } from 'hooks/batchOperations';

type mutationVariables = {
  sparkImageIDs: string[];
};

export function useRemoveSparkImages(sparkID?: string) {
  const queryClient = useQueryClient();
  const { mutateAsync: removeSparkCategories } = useBatchRemoveOperations();

  const removeSparkCategory = (mutationsVariables: mutationVariables) => {
    const categoryArray = mutationsVariables.sparkImageIDs.map((imageID) => ({
      type: SPARK_RESOURCE_TYPES.SPARK_IMAGES,
      id: imageID,
    }));

    return removeSparkCategories(categoryArray);
  };

  return useMutation('removeSparkCategory', removeSparkCategory, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(['sparkDiagnostics']);
      await queryClient.invalidateQueries([
        'sparks',
        ...(sparkID ? [sparkID] : []),
      ]);
    },
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`failed to remove Spark images: ${error.message}`);
      }
    },
  });
}
